__turbopack_context__.v({
  "cta": "CTABanner-module-scss-module__1r9hmq__cta",
  "ctaSideAd": "CTABanner-module-scss-module__1r9hmq__ctaSideAd",
  "fade": "CTABanner-module-scss-module__1r9hmq__fade",
  "fade-slide": "CTABanner-module-scss-module__1r9hmq__fade-slide",
  "getRecBtn": "CTABanner-module-scss-module__1r9hmq__getRecBtn",
  "open-from-center": "CTABanner-module-scss-module__1r9hmq__open-from-center",
  "spin": "CTABanner-module-scss-module__1r9hmq__spin",
});
